module.exports = __webpack_public_path__ + "static/media/RP_HorseracingTitle.962a35f70f45c0ee65a2a75a0052c471.png";